module.exports = __webpack_public_path__ + "static/media/payment-icon-mastercard.5888d9c6.svg";